<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
                <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
                <!-- <div class="delete" @click="delAll">批量删除</div>
                <div class="addData" @click="add">新增</div> -->
            </div>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
                <el-table-column sortable prop="diagnosisName" label="诊断名称"></el-table-column>
                <el-table-column sortable prop="diagnosisList" label="诊断(小类)">
                    <!-- <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.diagnosisList" :key="index">{{item}}</span>
                    </template> -->
                </el-table-column>
                <el-table-column sortable prop="chiefComplaint" label="主诉"></el-table-column>
                <el-table-column sortable prop="physicalExamination" label="查体"></el-table-column>
                <el-table-column sortable prop="latestMedicalHistory" label="现病史"></el-table-column>
                <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
                <el-table-column sortable prop="createTime" label="创建时间" width="100"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="forbidden" label="禁用" width="80">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="change(scope.$index, scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form :model="formData" label-width="140px">
                <el-form-item label="诊断名称">
                    <el-input v-model.trim="formData.diagnosisName" style="width:95%;" placeholder="请输入项目类别"></el-input>
                </el-form-item>
                <div>
                    <div v-for="(domain, idx) in formData.diagnosisList" :key="idx">
                        <el-form-item label="诊断">
                            <el-input v-model="domain.diagnosis" placeholder="请输入诊断" style="width:95%;" @input="testSX"></el-input>
                        </el-form-item>
                        <el-form-item label="主诉">
                            <el-input v-model.trim="domain.chiefComplaint" style="width:95%;" placeholder="请输入项目名称"></el-input>
                        </el-form-item>
                        <el-form-item label="现病史">
                            <el-input v-model.trim="domain.latestMedicalHistory" style="width:95%;" placeholder="请输入项目名称"></el-input>
                        </el-form-item>
                        <el-form-item label="查体">
                            <div class="flex">
                                <el-input style="width:90%;" v-model.trim="domain.physicalExamination" placeholder="请输入项目名称"></el-input>
                                <el-button size="mini" type="danger" @click.prevent="edit(domain,idx)">
                                    <i class="el-icon-delete"></i>
                                </el-button>
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item style="text-align: right;margin-right:5%;">
                        <el-button @click="addList" type="primary" size="mini">新增诊断</el-button>
                    </el-form-item>
                </div>

            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "diagnosis",
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                outpatientService: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {},
            tableHeight: "",
            isId: '',

        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        // 新增项目
        add() {
            this.dialogFormVisible = true
            this.isId = ''
            // 新增置空
            this.formData = {
                diagnosisName: '',
                diagnosisList: [
                    {
                        id: '',
                        diagnosis: '',
                        chiefComplaint: '',
                        latestMedicalHistory: "",
                        physicalExamination: '',
                    }
                ],

            }
        },

        handleEdit(index, row) {
            this.isId = row.id
            this.dialogFormVisible = true
            let querys = {
                id: row.id,
            }
            api.request('/diagnosis/findDiagnosisClassifyById', querys, (res) => {
                this.formData = res.data
            })
        },
        doAddgoods() {
            let data = {
                diagnosisName: this.formData.diagnosisName,
                diagnosisList: this.formData.diagnosisList,
                chiefComplaint: this.formData.chiefComplaint,
                latestMedicalHistory: this.formData.latestMedicalHistory,
                physicalExamination: this.formData.physicalExamination,
                createBy: Lockr.get('skinEmpId')
            }
            if (this.isId) {
                data.id = this.formData.id
                api.requestQuiet("/diagnosis/updateDiagnosisClassify", data, (res) => {
                    if (res.result == true) {
                        this.dialogFormVisible = false
                        _g.toast("success", '修改成功');
                        this.query(this.filters.pagination.page)
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            } else if (!this.isId) {
                api.requestQuiet("/diagnosis/createDiagnosisClassify", data, (res) => {
                    if (res.result == true) {
                        this.dialogFormVisible = false
                        _g.toast("success", '添加成功');
                        this.query(this.filters.pagination.page)
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            }

        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/diagnosis/findDiagnosisClassifyPage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
        // 编辑时删除诊断
        edit(item, listIndex) {
            var index = this.formData.diagnosisList.indexOf(item)
            if (index !== -1) {
                this.formData.diagnosisList.splice(listIndex, 1)
            }
            this.$forceUpdate()
        },
        // 编辑时新增诊断
        addList() {
            this.formData.diagnosisList.push({
                id: '',
                diagnosis: '',
                chiefComplaint: '',
                latestMedicalHistory: "",
                physicalExamination: '',
                key: Date.now()
            });
            this.$forceUpdate()
        },
        // 批量删除
        delAll() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                console.log(item)
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet(
                        "/diagnosis/deleteDiagnosisCategoryAll", {
                            idList: id.toString(),
                        },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        change(index, row) {
            let data = {
                id: row.id
                // 0：正常 1：禁用
            }
            api.request("/diagnosis/updateDiagnosisCategoryForbidden", data, (res) => {
                if (res.result == true) {
                    _g.toast("success", "状态修改成功")
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", "状态修改失败")
                    this.query(this.filters.pagination.page)
                }
            })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
.label {
  cursor: pointer;
}
</style>
